import React from "react";
import {dummyTermCondition } from "../../components/policy/Policy";

// Import or define your HTML string here

const TermConditions = ({ contentType = "privacy" }) => {

  return (
    <div
      dangerouslySetInnerHTML={{ __html: dummyTermCondition }}
    />
  );
};

export default TermConditions;
